import {
  BookingClient,
  CalendarClient,
  CategoryTeaserDto,
  DatabaseClient,
  DirectoryClient,
  GalleryClient,
  GeoClient,
  ModuleType,
  NewsClient,
  ProblemClient, ShopClient,
} from '../api/APIClient';
import { C7MODULE } from '../components/interfaces/component-properties';

export const getCategories = async (module: C7MODULE, page: number, categories: number[], includeEmpty: boolean, exclude: number[]): Promise<CategoryTeaserDto[]> => {

  if (module === C7MODULE.geo) {

    const client: GeoClient = new GeoClient();
    return await client.getCategories(page, includeEmpty, categories, exclude) as CategoryTeaserDto[];

  } else if (module === C7MODULE.calendar) {

    const client: CalendarClient = new CalendarClient();
    return await client.getCategories(page, includeEmpty, categories, exclude) as CategoryTeaserDto[];

  } else if (module === C7MODULE.news) {

    const client: NewsClient = new NewsClient();
    return await client.getCategories(page, includeEmpty, categories, exclude) as CategoryTeaserDto[];

  }

}

export const getCategoriesByModuleType = async (type: ModuleType, page: number, categories: number[], exclude: number[], includeEmpty: boolean = false): Promise<CategoryTeaserDto[]> => {
  switch (type) {
    case ModuleType.News:
      return await new NewsClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Geo:
      return await new GeoClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Calendar:
      return await new CalendarClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Directory:
      return await new DirectoryClient().getFormCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Database:
      return await new DatabaseClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Gallery:
      return new GalleryClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Problem:
      return new ProblemClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Shop:
      return new ShopClient().getCategories(page, includeEmpty, categories, exclude);
    case ModuleType.Booking:
      return new BookingClient().getCategories(page, includeEmpty, categories, exclude);
    default: {
      return [];
    }
  }
}
